import React, { Component } from "react";
import DOMPurify from "dompurify";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

var COOKIE_CONSENT_KEY = "botaniksan_cookie_consent";

class CookieConsent extends Component {
  state = {
    visible: false,
    showPolicy: false,
  };

  componentDidMount() {
    var accepted = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!accepted) {
      this.setState({ visible: true });
    }
  }

  handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, "true");
    this.setState({ visible: false, showPolicy: false });
  };

  togglePolicy = (e) => {
    e.preventDefault();
    this.setState({ showPolicy: !this.state.showPolicy });
  };

  getCookiePolicyPage() {
    var pages = this.props.page && this.props.page.page;
    if (!pages) return null;
    for (var i = 0; i < pages.length; i++) {
      if (pages[i].location === "cookie_policy" && pages[i].active) {
        return pages[i];
      }
    }
    return null;
  }

  renderPolicyModal() {
    var policyPage = this.getCookiePolicyPage();
    var content = policyPage ? policyPage.content : "";
    var title = policyPage
      ? policyPage.content_title || policyPage.menu_title
      : "Çerez Politikası";

    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 10001,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "rgba(0,0,0,0.6)",
        }}
        onClick={this.togglePolicy}
      >
        <div
          style={{
            backgroundColor: "#fff",
            borderRadius: "8px",
            maxWidth: "700px",
            width: "90%",
            maxHeight: "80vh",
            display: "flex",
            flexDirection: "column",
            boxShadow: "0 10px 40px rgba(0,0,0,0.3)",
          }}
          onClick={function (e) {
            e.stopPropagation();
          }}
        >
          {/* Modal Header */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "20px 25px",
              borderBottom: "1px solid #e5e5e5",
              backgroundColor: "#f8f9fa",
              borderRadius: "8px 8px 0 0",
            }}
          >
            <h4
              style={{
                margin: 0,
                fontSize: "18px",
                fontWeight: "600",
                color: "#333",
                fontFamily: "'Poppins', sans-serif",
              }}
            >
              <FontAwesomeIcon
                icon={["fas", "shield-alt"]}
                style={{ marginRight: "10px", color: "#88c000" }}
              />
              {title}
            </h4>
            <button
              onClick={this.togglePolicy}
              style={{
                background: "none",
                border: "none",
                fontSize: "22px",
                cursor: "pointer",
                color: "#999",
                padding: "0 5px",
                lineHeight: 1,
              }}
            >
              &times;
            </button>
          </div>

          {/* Modal Body */}
          <div
            style={{
              padding: "25px",
              overflowY: "auto",
              flex: 1,
              fontSize: "14px",
              lineHeight: "1.7",
              color: "#555",
            }}
          >
            {content ? (
              <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content) }} />
            ) : (
              <p
                style={{
                  color: "#999",
                  textAlign: "center",
                  padding: "40px 0",
                }}
              >
                Çerez politikası içeriği henüz eklenmemiş. Yönetim panelinden
                "Çerez Politikası" konumunda bir sayfa oluşturabilirsiniz.
              </p>
            )}
          </div>

          {/* Modal Footer */}
          <div
            style={{
              padding: "15px 25px",
              borderTop: "1px solid #e5e5e5",
              textAlign: "right",
              backgroundColor: "#f8f9fa",
              borderRadius: "0 0 8px 8px",
            }}
          >
            <button
              onClick={this.togglePolicy}
              style={{
                padding: "8px 20px",
                border: "1px solid #ddd",
                borderRadius: "4px",
                backgroundColor: "#fff",
                color: "#666",
                cursor: "pointer",
                fontSize: "14px",
                marginRight: "10px",
                transition: "all 0.3s",
              }}
            >
              Kapat
            </button>
            <button
              onClick={this.handleAccept}
              style={{
                padding: "8px 25px",
                border: "none",
                borderRadius: "4px",
                backgroundColor: "#88c000",
                color: "#fff",
                cursor: "pointer",
                fontSize: "14px",
                fontWeight: "600",
                transition: "all 0.3s",
              }}
            >
              Kabul Ediyorum
            </button>
          </div>
        </div>
      </div>
    );
  }

  render() {
    if (!this.state.visible) return null;

    return (
      <React.Fragment>
        {/* Cookie Consent Banner */}
        <div
          style={{
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 10000,
            backgroundColor: "rgba(26, 26, 26, 0.8)",
            borderTop: "3px solid #88c000",
            boxShadow: "0 -5px 20px rgba(0,0,0,0.2)",
          }}
        >
          <div className="container">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "18px 0",
                flexWrap: "wrap",
              }}
            >
              {/* Icon & Text */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  flex: 1,
                  minWidth: "280px",
                  marginRight: "20px",
                  marginBottom: "10px",
                }}
              >
                <div
                  style={{
                    width: "44px",
                    height: "44px",
                    borderRadius: "50%",
                    backgroundColor: "rgba(136, 192, 0, 0.15)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginRight: "15px",
                    flexShrink: 0,
                  }}
                >
                  <FontAwesomeIcon
                    icon={["fas", "cookie-bite"]}
                    style={{ color: "#88c000", fontSize: "20px" }}
                  />
                </div>
                <div>
                  <p
                    style={{
                      margin: 0,
                      color: "#e0e0e0",
                      fontSize: "14px",
                      lineHeight: "1.6",
                      fontFamily: "'Open Sans', sans-serif",
                    }}
                  >
                    Bu web sitesi, size en iyi deneyimi sunmak için çerezleri
                    kullanmaktadır. Sitemizi kullanmaya devam ederek{" "}
                    <a
                      href="#cerez-politikasi"
                      onClick={this.togglePolicy}
                      style={{
                        color: "#88c000",
                        textDecoration: "underline",
                        fontWeight: "600",
                        cursor: "pointer",
                      }}
                    >
                      Çerez Politikamızı
                    </a>{" "}
                    kabul etmiş olursunuz.
                  </p>
                </div>
              </div>

              {/* Buttons */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  flexShrink: 0,
                }}
              >
                <a
                  href="#cerez-politikasi"
                  onClick={this.togglePolicy}
                  style={{
                    padding: "10px 18px",
                    border: "1px solid rgba(255,255,255,0.2)",
                    borderRadius: "4px",
                    backgroundColor: "transparent",
                    color: "#ccc",
                    cursor: "pointer",
                    fontSize: "13px",
                    textDecoration: "none",
                    transition: "all 0.3s",
                    whiteSpace: "nowrap",
                  }}
                >
                  <FontAwesomeIcon
                    icon={["fas", "info-circle"]}
                    style={{ marginRight: "6px" }}
                  />
                  Detaylı Bilgi
                </a>
                <button
                  onClick={this.handleAccept}
                  style={{
                    padding: "10px 25px",
                    border: "none",
                    borderRadius: "4px",
                    backgroundColor: "#88c000",
                    color: "#fff",
                    cursor: "pointer",
                    fontSize: "14px",
                    fontWeight: "700",
                    letterSpacing: "0.3px",
                    transition: "all 0.3s",
                    whiteSpace: "nowrap",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                >
                  <FontAwesomeIcon
                    icon={["fas", "check"]}
                    style={{ marginRight: "6px" }}
                  />
                  Kabul Ediyorum
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Policy Modal */}
        {this.state.showPolicy && this.renderPolicyModal()}
      </React.Fragment>
    );
  }
}

var mapStateToProps = function (state) {
  return {
    page: state.page,
  };
};

export default connect(mapStateToProps)(CookieConsent);



// WEBPACK FOOTER //
// ./src/components/CookieConsent.js